import React from 'react';
import ReactLogo from "../assets/img/tlogo.png";

export const Preloader = (props) => {
  const { show } = props;

  return (
    show && (
      <div className={`fixed inset-0 z-50 flex flex-col justify-center items-center bg-light ${show ? "" : "hidden"}`}>
        <img className="animate-bounce" src={ReactLogo} height={40} alt="Loading..." style={{ height: 40 }} />
      </div>
    )
  );
};
